import { isLocalStorageSupported } from 'javascripts/utils';

// because of a bug in the original code, the key is always 'categoriesState-undefined'
const SAVED_CATEGORIES_KEY = 'categoriesState-undefined';

const getSavedCategoriesState = () => {
  let raw;

  if (isLocalStorageSupported()) {
    raw = localStorage.getItem(SAVED_CATEGORIES_KEY);
  }

  if (raw && typeof raw === 'string') {
    return JSON.parse(raw);
  } else {
    return {};
  }
};

// Persist the open/closed state of the filter categories
const setSavedCategoriesState = (category, on = true) => {
  if (isLocalStorageSupported()) {
    const savedCategoriesState = getSavedCategoriesState();

    if (on) {
      savedCategoriesState[category] = true;
    } else {
      savedCategoriesState[category] = false;
    }

    localStorage.setItem(
      SAVED_CATEGORIES_KEY,
      JSON.stringify(savedCategoriesState)
    );
  }
};

export { getSavedCategoriesState, setSavedCategoriesState };
